import { useHasPermission } from '@/features/access-control';
import { SETTINGS_PERMISSIONS } from '@/features/auth/company-switch';

// Reuses the sidebar CompanySwitch's own permission set (see useCompanySwitchScope) so both
// entry points to /app/settings agree on who can see it. useHasPermission reads from the same
// cached usePermissions() query CompanySwitch already fires, so this adds no extra request.
export const useTopBarSettingsAccess = () => {
	const { hasPermission: hasSettingsAccess } = useHasPermission([...SETTINGS_PERMISSIONS], 'any');

	return { hasSettingsAccess };
};
